import { PAGEPATHS, SIDEBARDATA, DEFAULTADMINPAGE, USERTYPES } from "components/Common/Constant";
import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const Authmiddleware = (props) => {
  const user = useSelector((state) => state?.users.users)
  const path = useLocation()

  if (!user || Object.keys(user).length === 0) {
    return (
      <Navigate to={{ pathname: PAGEPATHS.Login, state: { from: props.location } }} />
    );
  }

  if (user) {
    const cleanedPath = path.pathname.replace(/\/+$/, '');
    const page = SIDEBARDATA.find(obj => obj.route === cleanedPath)
    if (page && typeof cleanedPath === 'string') {
      const isAdmin = user.userType === USERTYPES.Admin;
      const isAdminPage = DEFAULTADMINPAGE.includes(page?.pageCode);

      // Admin users have automatic access to all default admin pages
      if (isAdmin && isAdminPage) {
        // Allow access
        return (<React.Fragment>
          {props.children}
        </React.Fragment>);
      }

      // All other users need explicit permissions
      if (!user.permissions || !user.permissions.read.includes(page?.pageCode)) {
        return (
          <Navigate to={{ pathname: PAGEPATHS.Forbidden }} />
        );
      }
    }
  }

  return (<React.Fragment>
    {props.children}
  </React.Fragment>);
};

export default Authmiddleware;
